import React, { useMemo } from 'react';
import Iframe from 'react-iframe';
import { buildConsoleUrl } from '../../config/consoleThemes';

function ConsoleComponent({ theme = 'ocean' }) {
  const baseUrl = window.__RUNTIME_CONFIG__?.REACT_APP_CONSOLE_URI;

  const consoleUrl = useMemo(() => {
    if (!baseUrl) return '';
    return buildConsoleUrl(baseUrl, theme);
  }, [baseUrl, theme]);

  if (!consoleUrl) {
    return <div className='console-iframe-empty'>Console URL is not configured.</div>;
  }

  return (
    <div className='console-iframe-wrap'>
      <Iframe
        key={consoleUrl}
        url={consoleUrl}
        width='100%'
        styles={{ border: 'none', height: '100%', width: '100%', display: 'block' }}
        sandbox={['allow-forms', 'allow-scripts', 'allow-same-origin']}
        allow='clipboard-read; clipboard-write'
      />
    </div>
  );
}

export default ConsoleComponent;
